module.exports = __webpack_public_path__ + "static/assets/420ac8dcfdacd63b159f8cf2033a4f31.png";